module.exports = __webpack_public_path__ + "media/images/illustrations/top-us-schools-b9b207a8dbdb49f1e7d4b9ac0206641a.svg";